import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CustomgridOptions, GridColConfig } from 'src/app/core/custom-grid/custom-grid';
import { FieldConfig, FieldTypeEnum } from 'src/app/core/dynamic-form/dynamicForm.interface';
import { TestService } from '../test.service';
import { ToastService } from 'src/app/core/toast/toast.service';
import { EditSettingsModel, PageSettingsModel } from '@syncfusion/ej2-angular-grids';


@Component({
  selector: 'app-grid-test',
  templateUrl: './grid-test.component.html',
  styleUrls: ['./grid-test.component.scss'],
})
export class GridTestComponent implements OnInit, AfterViewInit, OnDestroy{

  formConfig: FieldConfig[] = [];


  colorPicker:any;

  private theEnd$ = new Subject<void>();

  gridOptions: GridColConfig[] = [];
  tableOptions: CustomgridOptions = {
    apiCallurl: '/api/modelli/mazzette/11',
    //apiCallurl: `/api/anagrafiche/automezzi/get/lazy`,
    apiTableName: 'q',
    rowsCallurl: '',
  };

  pageSettings: PageSettingsModel = {
    pageSize: 25,
    pageSizes: [25, 50, 100],
    pageCount: 10,
    currentPage: 1,
  };

  editSettings: EditSettingsModel = {
    allowEditing: true,
  };

  constructor(
    private testService: TestService,
    private toastService: ToastService,
  ){

  }

  ngOnInit(): void {    
    
    this.formConfig = [
      {
        name: 'colorPicker',
        type: FieldTypeEnum.multi,
        label: 'Scegli i colori bro',
        options: {
          api: true,
          url: 'colori-svg',
          showColor: true,
        }
      },
      {
        name: 'colorPickerSingle',
        type: FieldTypeEnum.select,
        label: 'Scegli il colore bro',
        options: {
          api: true,
          url: 'colori-svg',
          showColor: true,
        }
      }
    ];

    this.gridOptions = [
      {
        field: 'idModello',
        name: 'Id modello',
        type: 'text',
        fieldOptions: {

        },
      },
      {
        field: 'id',
        name: 'Id',
        type: 'text',
        fieldOptions: {

        },
      },
      {
        field: 'codiceMazzetta',
        name: 'Mazzetta',
        type: 'text',
        fieldOptions: {

        },
      },
      {
        field: 'prezzoM2',
        name: 'Prezzo m²',
        type: 'text',
        textFieldOptions: {
          append: '€',          
        },
        fieldOptions: {

        },
      }
    ];
  }

  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
  }


  onFormChanges(event:any) {

  }

  action(event:any) {

  }

  flick() {
    this.testService.ppFlick().pipe(takeUntil(this.theEnd$)).subscribe({
      next: (res: string) => {        
        this.toastService.GenerateToast({
          title: 'MUHAHAHAHAHAHA',
          content: `I FLICKED YOUR PP !!!!`,
          severity: 'e-toast-success',
        });
        console.info(`\n \n \n LOL THIS IS A REMINDER THAT I FLICKED YOUR PP \n ${res} \n \n \n`);
      },
      error: (err: any) => {
        console.error("DAMN I COULDN'T FLICK YOUR PP T_T");
        console.error(err);        
        this.toastService.GenerateToast({
          title: 'NOOOOOOOOOOOOOOOOOOOOOO',
          content: `I COULD NOT FLICK YOUR PP !!!!`,
          severity: 'e-toast-danger',
        });      
      }
    });
  }

  yap() {
    this.testService.yap().subscribe({
      next: () => {
        console.info("OK");
      }
    })
  }

}
